import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, TemplateRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeCourt } from '../../../../shared/models/jobTypeCourt.model';

import { BsModalService } from 'ngx-bootstrap/modal';
// Quill Editor
// import { QuillEditorModule } from 'ngx-quill-editor';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below

import { JobTypeDocument } from '../../../../shared/models/jobTypeDocument.model';
import { JobTypeAffidavit } from '../../../../shared/models/jobTypeAffidavit.model';

import { DatePipe } from '@angular/common';
import { Location } from '@angular/common';
import { Project } from 'src/app/shared/models/project';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';


@Component({
  selector: 'app-projects-edit',
  templateUrl: './projects-edit.component.html',
  styleUrls: ['./projects-edit.component.scss']
})
export class ProjectsEditComponent implements OnInit {


  @Input() intialCount = 221;
  @Input() count = this.intialCount;
  // sees if there is a change in myCount
@Output()
change: EventEmitter<number> = new EventEmitter<number>();
  job_type: Object;
  job_type_courts: Object;
  sent_job_type_location_id: any;
  job_type_document: Object;
  job_type_document_types: Object;
  sent_job_type_court_id: any;
  job_type_affidavit: Object;

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  job_service_rule: Object;
  project: any;
  @Input() project_id?: number;
  brands: any;
  model: Project;
  sendTypeID: any;
  modalRef: any;

  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, viewRef: ViewContainerRef,
     private _location: Location,  public gfunc: GlobalFunctionsService,
     public datepipe: DatePipe,
  ) { 

    this.project_id = +this.route.snapshot.paramMap.get('project_id');
  }

  ngOnInit() {

    // just need the project ID 


    // this.change.emit(this.intialCount);
    // this.getTraceCandidate(this.count);
   this.model = new Project();
  //  this.project_id = this.count;
  this.getProject(this.project_id);
  }



  getProject(project_id) {
    this._demoService.getProject(project_id).subscribe(
       data => { this.project = data; 
        let res = data[0];
        // this.getJob(res.job_id);
       // this.model.job_type_id = res.job_type_id;
        // this.getJobTypeLocations(res.job_type_id);
        // this.getJobTypeCourts(res.job_type_location_id);
        // this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

 openModalScript(project_id) {
  this.sendTypeID(project_id);
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(this.templateCreate, config);
}
  templateCreate(templateCreate: any, config: { backdrop: boolean; ignoreBackdropClick: boolean; class: string; }): any {
    throw new Error('Method not implemented.');
  }

// :: Parent / Child modal test
// closeParentModel() {
//   // alert('parent component function.');
//   this.modalRef.hide();
//   this.refreshGrid(); // resets the grid if updated and closed.
// //  this.updateTypeClick = false; // closes the div
// };


   // to router navigate back
   public goBack() {
    this._location.back();
    }

}
